import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Legend, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabI as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabI = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const paidWithGrantFundsField = () => {
    const propertyName = pn<AprResponseModel>("paidWithGrantFunds");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.paidWithGrantFunds} {formatPercentTotal(props.data?.paidWithGrantFunds, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const attendSchoolsDistrictNoCostField = () => {
    const propertyName = pn<AprResponseModel>("attendSchoolsDistrictNoCost");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.attendSchoolsDistrictNoCost} {formatPercentTotal(props.data?.attendSchoolsDistrictNoCost, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const targetSchoolsPartnerNoCostField = () => {
    const propertyName = pn<AprResponseModel>("targetSchoolsPartnerNoCost");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.targetSchoolsPartnerNoCost} {formatPercentTotal(props.data?.targetSchoolsPartnerNoCost, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const thirdPartyTuitionWaiversField = () => {
    const propertyName = pn<AprResponseModel>("thirdPartyTuitionWaivers");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.thirdPartyTuitionWaivers} {formatPercentTotal(props.data?.thirdPartyTuitionWaivers, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const otherField = () => {
    const propertyName = pn<AprResponseModel>("other");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.other} {formatPercentTotal(props.data?.other, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
        {props.totalTabA != props.data?.totalParticipants && (
          <Typography color="error" variant="caption">
            Your Total Participants does not equal Total Participants in section A
          </Typography>
        )}
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
      <Typography variant="h5">Participants Enrolled in Rigorous Courses That Are Not Offered at Target Schools</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              <Grid item xs={12}>
                {paidWithGrantFundsField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {attendSchoolsDistrictNoCostField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {targetSchoolsPartnerNoCostField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {thirdPartyTuitionWaiversField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {otherField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          <Grid item xs={6}>
            <PieChart id="pie-tab-i" dataSource={props.data?.chartValues} palette="Bright" title="Participants" width="100%">
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid>
          
        </Grid>
      </Stack>
    </Card>
  );
};
